
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/introducing-the-row-grouping-feature",
      function () {
        return require("private-next-pages/blog/introducing-the-row-grouping-feature.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/introducing-the-row-grouping-feature"])
      });
    }
  